export const operatorLabel = (quantifier, isHas, t)=>{
    if (quantifier !== 'none') return undefined;
    return isHas ? t.servicesOperatorHasNo() : t.servicesOperatorIsNot();
};
